




















































































import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator'
import { TypeformCredentials } from '@/api/model/credentials'
import { RealworksAPI } from '@/api/client/realworks'

@Component
export default class EditTypeformForm extends Vue {
    @Inject() readonly reloadCompany: () => Promise<void>
    @Prop({ required: true }) currentCredentials!: TypeformCredentials
    @Prop({ required: true }) credentials!: TypeformCredentials
    type: string = 'shared'
    loadingAgendaTypes: boolean = true
    agendaTypes = []

    mounted() {
        this.type = this.currentCredentials.apiKey ? 'private' : 'shared'
        this.loadAgendaTypes()
    }

    @Watch('type')
    onTypeChange() {
        if (this.type === 'shared') {
            this.credentials.apiKey = ''
        }
    }

    async loadAgendaTypes() {
        this.loadingAgendaTypes = true

        const agendaTypes = await RealworksAPI.getAgendatypes()
        this.agendaTypes = agendaTypes
            .map(agendatype => ({
                label: agendatype,
                value: agendatype,
            }))
            .sort((a, b) => a.label.localeCompare(b.label))

        this.loadingAgendaTypes = false
    }

    get yesNoOptions() {
        return [
            { label: this.$t('yes'), value: true },
            { label: this.$t('no'), value: false },
        ]
    }

    get isActivated(): boolean {
        return this.currentCredentials.workspaceId !== null
    }
}
